// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"554":"OnfidoForm","653":"ProjectionsChart"}[chunkId] + "." + {"554":"fdde414ff002e91bc439","653":"350a8bbe8df7e6d2976e"}[chunkId] + ".css";
};